import React from "react";
import ProfileCard from "../../components/ProfileCard/ProfileCard";

export default function ProfileList({
  data,
  user,
  role,
  subjectExpertise,
  mentorshipOffered,
}) {
  return data.map((item) => (
    <ProfileCard
      key={item.id}
      profileData={user === "mentors" ? item.mentor : item.author}
      user={user}
      rating={5}
      badge={"Highly Rated Expert"}
      role={role}
      subjectExpertiseList={subjectExpertise}
      mentorshipOfferedList={mentorshipOffered}
      imparcId={item.imparcId}
    />
  ));
}
